import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import Image from "../../Components/Reusable/Image";
import { Link, useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import * as Yup from "yup";
import { handleApiErrors, InputType, validationRegex } from "../../Utils/Utils";
import { toast } from "react-toastify";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { AuthContext } from "../../Context/authContext";
import BharatSatService from "../../Services/BharatSatService";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import ClassService from "../../Services/ClassService";
import DataProvider from "../../Utils/DataProvider";
import moment from "moment";
import CouponServices from "../../Services/CouponServices";
import DatePicker from "react-datepicker";
import Calanderimg from "../../assets/images/png/fi_12671954.png";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import dayjs from "dayjs";
import * as XLSX from "xlsx";

const ViewCoupans = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [editData, setEditData] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [generate, setGenerate] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [selectedClassFilter, setSelectedClassFilter] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const [mediumList, setMediumList] = useState(DataProvider.mediumList);
  const { user } = useContext(AuthContext);
  const [dataExport, setDataExport] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterDistricts, setFilterDistricts] = useState([]);
  const [resetDistrict, setResetDistrict] = useState(false);
  const [resetFilterDistrict, setResetFilterDistrict] = useState(false);
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState("");
  const [talukas, setTalukas] = useState([]);
  const [filterTalukas, setFilterTalukas] = useState([]);
  const [resetTaluka, setResetTaluka] = useState(false);
  const [resetFilterTaluka, setResetFilterTaluka] = useState(false);
  const [selectedDiscountType, setSelectedDiscountType] = useState("");
  const [applicablePackages, setApplicablePackages] = useState([]);
  const [selectedApplicablePackages, setSelectedApplicablePackages] = useState(
    []
  );
  const [discounttype, setDiscounttype] = useState([
    { label: "Percentage", value: "percentage" },
    { label: "Flat", value: "flat" },
  ]);
  const navigate = useNavigate();

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const fetchData = async () => {
    try {
      const response = await CouponServices.getCoupons(
        offset,
        limit,
        selectedDiscountType || "",
        selectedApplicablePackages || "",
        startDate,
        endDate
      );

      setData(response.couponData);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllCouponsWithoutPagination = async () => {
    try {
      // Validate startDate and endDate before formatting
      const formattedStartDate = startDate
        ? dayjs(startDate).format("YYYY-MM-DD")
        : "";
      const formattedEndDate = endDate
        ? dayjs(endDate).format("YYYY-MM-DD")
        : startDate
        ? dayjs(new Date()).format("YYYY-MM-DD")
        : "";

      const response = await CouponServices.getAllCouponsWithoutPagination(
        formattedStartDate,
        formattedEndDate
      );
      setDataExport(response.couponData);
      // setAvailableDataCount(response.availableDataCount);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const ChangeStatus = async (id, status) => {
    try {
      await CouponServices.updateCouponStatus(id, status);
      toast.success("Coupon Status Updated successfully");
      var updatedData = data;
      updatedData[
        updatedData.findIndex((item) => item.couponId === id)
      ].is_active = status;
      setEditData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  useEffect(() => {
    const fetchUserDataByDate = () => {
      if (startDate || endDate) {
        fetchData(startDate, endDate);
        getAllCouponsWithoutPagination(startDate, endDate);
      }
    };

    const timeoutId = setTimeout(fetchUserDataByDate, 500); // Debounce the request

    return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
  }, [startDate, endDate]);
  const deleteSingleExam = async (id) => {
    try {
      await CouponServices.deleteCoupon([id]);
      toast.success("Coupon Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleExam = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.couponId);
          }
        });
      }
      await CouponServices.deleteCoupon(itemsToDelete);
      toast.success("Coupons Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    fetchData();
    getAllClasses();
    getAppicablePackagesWithoutPagination();
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        selectedApplicablePackages != null ||
        selectedDiscountType != null ||
        startDate != null ||
        endDate != null
      ) {
        fetchData();
        getAllCouponsWithoutPagination();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [selectedApplicablePackages, selectedDiscountType, startDate, endDate]);

  // const removeTimeFromDate = (dateString) => {
  //   if (!dateString) return '';
  //   const dateObject = new Date(dateString);
  //   // Ensure the date is parsed as UTC
  //   const utcYear = dateObject.getUTCFullYear();
  //   const utcMonth = dateObject.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
  //   const utcDay = dateObject.getUTCDate();
  //   return `${utcDay} ${utcMonth} , ${utcYear}`;

  // };

  const formatTimeTo12Hour = (isoTime) => {
    if (!isoTime) return "";

    // Use Moment.js to parse the ISO time string and format it in 12-hour format with AM/PM
    return moment(isoTime).format("hh:mm A");
  };
  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="From"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const CustomDateInputTo = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="To"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const exportToExcel = (data, fileName) => {
    console.log(data, "data");
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);

    // Define the grand total row
    const grandTotalRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      // "Grand Total",
    ];

    // Add grand total row to the end of the sheet
    XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };
  const handleExportClick = () => {
    const name = user.name || "";
    const fileName = `${name} Coupon Data Report.xlsx`;
    exportToExcel(dataExport, fileName);
  };
  const getAppicablePackagesWithoutPagination = async () => {
    try {
      const response =
        await CouponServices.getAppicablePackagesWithoutPagination();
      setApplicablePackages(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">Coupon Code List</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Coupon Code List</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <h1 className="black fs-18 fw-600 mb-0">Coupon Code list </h1>

        <div className="table_title">
          <div className="table_headings mt-4 Commonclass">
            <h1 className="black fs-18 fw-600 mb-0">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                  pointerEvents:
                    data?.findIndex((item) => item.isChecked) === -1
                      ? "none"
                      : "auto",
                }}
                onClick={() => {
                  const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Coupon"
                  );

                  if (!viewBharaSatExamPreviledge?.delete) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning(
                      "You don't have permission to delete Coupon."
                    );
                    return;
                  }
                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
          </div>
          <div className=" row table_title pb-0 align-items-center justify-content-end responsivetablepackagetwo">
            <div className=" col-lg-6 col-md-6  gap-2 col-12 pe-0 d-flex justify-content-end  align-items-center sectionPayouts  datepickerstyle">
              <div className="">Date:</div>
              <div>
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  placeholderText="From"
                  maxDate={new Date()}
                  customInput={<CustomDateInput />}
                />
              </div>
              <div>
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  placeholderText="To"
                  minDate={startDate}
                  maxDate={new Date()}
                  customInput={<CustomDateInputTo />}
                />
              </div>
            </div>
            {/* <div className="col-xl-7 my-2 col-lg-12 col-md-12 gap-2 Responsivesearchbars  align-items-center d-flex"> */}
            <div className="col-lg-2  col-md-6  col-sm-12 ">
              <CustomDropDown
                placeholder="Select discount type"
                inputType={InputType.text}
                resetValue={resetFilterTaluka}
                Dropdownclass="marginsection"
                labelClass="commissionsection"
                options={discounttype}
                onChange={(selectedOptions) => {
                  setSelectedDiscountType(selectedOptions.value);
                  console.log(selectedDiscountType, "selectedDiscountType"); // Use selectedOptions instead of value
                }}
                defaultOption={() => {
                  return data.discountType
                    ? {
                        value: data.discountType,
                        label: data.discountType,
                      }
                    : null;
                }}
              />
            </div>
            <div className="col-lg-2 col-md-6   col-sm-12">
              <CustomDropDown
                placeholder="Select Packages"
                inputType={InputType.text}
                resetValue={resetFilterTaluka}
                Dropdownclass="marginsection"
                labelClass="commissionsection"
                setResetValue={setResetFilterTaluka}
                onChange={(selectedOptions) => {
                  setSelectedApplicablePackages(selectedOptions.value);
                  console.log(
                    selectedApplicablePackages,
                    "selectedApplicablePackages"
                  ); // Use selectedOptions instead of value
                }}
                options={applicablePackages?.map((e) => {
                  return { value: e.package_id, label: e.packageName };
                })}
                // defaultOption={{
                //   value: selectedApplicablePackages,
                //   label: selectedApplicablePackages || "Select Packages",
                // }}
              />
            </div>
            <div className="col-lg-2  col-md-6 col-sm-12 d-flex align-items-center justify-content-end respoexportbtn ">
              <ButtonWithIcon
                text={"Export"}
                icon={PngImages.xlspic}
                onClick={handleExportClick}
              />
            </div>
            {/* </div> */}
          </div>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            className="table mb-0 mt-3"
            id="dtHorizontalExample"
            cellSpacing="0"
            width="100%"
          >
            <thead>
              <tr className="table_heading">
                <th scope="col" style={{ width: "5%" }}>
                  <label className="d-flex align-items-center justify-content-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      style={{ height: "16px", aspectRatio: 1 }}
                      checked={
                        data?.length > 0 &&
                        data?.findIndex((item) => !item.isChecked) == -1
                      }
                      onChange={(value) => {
                        var updatedData = data;
                        updatedData.map((element) => {
                          element.isChecked = value.target.checked;
                        });
                        setData([...updatedData]);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Created Date
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Coupon Code
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Discount Type
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Start Date
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  End Date
                </th>

                {/* <th scope="col" style={{ width: "5%" }}>
                    View Question Paper
                  </th> */}
                {/* <th scope="col" style={{ width: "5%" }}>
                    Generate E-Hall Ticket
                  </th> */}
                <th scope="col" style={{ width: "5%" }}>
                  Current Status
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg_light">
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={item.isChecked || false}
                        style={{ height: "16px", aspectRatio: 1 }}
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData[index].isChecked = value.target.checked;
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                  <td>{limit * offset + (index + 1)}</td>
                  <td>{moment(item.created_date).format("DD-MM-YYYY")}</td>
                  <td>{item.couponCode}</td>
                  <td>{item.discountType}</td>
                  <td>
                    {moment(item.validity.startDate).format("DD-MM-YYYY")}
                  </td>
                  <td>{moment(item.validity.endDate).format("DD-MM-YYYY")}</td>
                  {/* <td >
                    <Link to={`${RoutesPath.bharatSatQuestionsDetails}/${item.bharatSatExamId}`} className="cursor-pointer anchorlink " >
                        View
                      </Link>
                    </td> */}
                  {/* <td>
                    <a
                        className="cursor-pointer anchorlink"
                        onClick={() => {
                          if(item.ehallTicketGenerated == false){
                            setShowTicketModal(true);
                          }else{
                            toast.success("Your Hall Ticket is Already generated")
                          }
                          setGenerate(item.bharatSatExamId)
                        }}
                      >{item.ehallTicketGenerated == true ? "Already Generated":"Generate"}
                      </a>
                    </td> */}
                  <td>
                    <label
                      className="switch"
                      data-bs-target="#change_status"
                      data-bs-toggle="modal"
                    >
                      <input
                        type="checkbox"
                        checked={item.is_active}
                        onChange={() => {
                          const viewBharaSatExamPreviledge =
                            user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Coupon"
                            );
                          if (!viewBharaSatExamPreviledge?.update) {
                            toast.warning(
                              "You don't have permission to update the status."
                            );
                            return;
                          }

                          setShowConfirmationModal(true);
                          setStatusChangeData(item);
                        }}
                      />
                      <span className="slider round"></span>
                    </label>
                  </td>
                  <td>
                    <div className="d-flex gap_8">
                      <a
                        onClick={() => {
                          const viewBharaSatExamPreviledge =
                            user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Coupon"
                            );

                          if (!viewBharaSatExamPreviledge?.update) {
                            toast.warning(
                              "You don't have permission to edit Coupon."
                            );
                            return;
                          }
                          navigate(RoutesPath.editcoupan, {
                            state: item,
                          });
                        }}
                        className="edit_icons cursor-pointer"
                        data-bs-target="#editclass"
                        data-bs-toggle="modal"
                      >
                        <Image
                          src={SvgImages.edit}
                          style={ImageFilters.green}
                          className="add_icons"
                          alt="Edit Icon"
                        />
                      </a>
                      <a
                        className="delete_icons cursor-pointer"
                        onClick={() => {
                          const viewBharaSatExamPreviledge =
                            user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Coupon"
                            );
                          if (!viewBharaSatExamPreviledge?.delete) {
                            toast.warning(
                              "You don't have permission to delete Coupon."
                            );
                            return;
                          }
                          setDeleteId(item.couponId);
                          setIsMultipleDelete(false);
                          setShowDeleteModal(true);
                        }}
                      >
                        <Image
                          src={SvgImages.deleteIcon}
                          style={ImageFilters.red}
                          data-bs-target="#delete-modal"
                          data-bs-toggle="modal"
                          alt="Delete Icon"
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {generatePaginationFooter(availableDataCount, limit, offset, setOffset)}
      </div>
      {/* Change Class Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(
            getStatusChangeData.couponId,
            !getStatusChangeData.is_active
          );
        }}
        theme={ConfirmationModalTheme.warning}
      />

      {/* Delete blog category Modal */}

      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected Coupon?"
            : "Are you sure want to delete Coupon?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleExam() : deleteSingleExam(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
      {/* Add Class Modal */}
    </div>
  );
};

export default ViewCoupans;
